export const ApplicationActions = {
    UPDATE_MAP: "UPDATE_MAP",
    ERROR_MAP: "ERROR_MAP",
    LOADING_MAP: "LOADING_MAP",
    CONTAINER_PLAN_LOADED: "CONTAINER_PLAN_LOADED",
    BACK_SELECTED: "BACK_SELECTED"
};
